<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(sealBelongCompanyName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.sealBelongCompanyName)">{{ data.item.sealBelongCompanyName }}</div>
      </template>

      <template v-slot:cell(sealText)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.sealText)">{{ data.item.sealText }}</div>
      </template>

      <template v-slot:cell(reason)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.reason)">{{ data.item.reason }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "AamsRegSealUsageRecordDetail",
  data() {
    return {
      fields1: [
        {key: 'sealBelongCompanyName', label: '印章所属公司', width: '120px'},
        {key: 'sealCategoryName', label: '印章类别', width: '120px'},
        {key: 'sealText', label: '印文全称', width: '120px'},
        {key: 'usageMethodLabel', label: '用印方式', width: '120px'},
        {key: 'sealReasonCategoryName', label: '用印事由类别', width: '120px'},
        {key: 'reason', label: '用印事由', width: '120px'},
        {key: 'quantity', label: '用印份数', width: '120px'},
        {key: 'retainQuantity', label: '留存份数', width: '120px'},
        {key: 'expectedStartDate', label: '预计使用开始时间', width: '140px'},
        {key: 'expectedEndDate', label: '预计使用结束时间', width: '140px'},
        {key: 'actualUsageDate', label: '实际使用时间', width: '140px'},
        {key: 'actualBorrowDate', label: '实际借出时间', width: '140px'},
        {key: 'operatorName', label: '用印经办人', width: '120px'},
        {key: 'borrowerName', label: '借出人', width: '120px'},
        {key: 'returnerName', label: '归还人', width: '120px'},
        {key: 'returnDate', label: '归还时间', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>